// extracted by mini-css-extract-plugin
export default {"video-container":"styles_video-container__kdmAQ","stx-video":"styles_stx-video__1XEjU","stx-canvas":"styles_stx-canvas__ts-Uf"};